import { render, staticRenderFns } from "./scratch-card-item.vue?vue&type=template&id=6ed3b500&"
import script from "./scratch-card-item.vue?vue&type=script&lang=js&"
export * from "./scratch-card-item.vue?vue&type=script&lang=js&"
import style0 from "./scratch-card-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports